<!-- 新增收货地址页 -->
<template>
 
    <div class="webwrap">
      <div class="inputForm_info">
         <div class="telDiv">
          <span>用户昵称：</span>
           <input type="text" placeholder="请输入用户昵称" v-model="nickName">
        </div>

        <div class="telDiv">
          <span>手机号：</span>
          <input type="text" placeholder="请输入手机号" :value="mobile" disabled />
          <!-- <input type="number" placeholder="请输入手机号" v-model="mobile" disabled> -->
        </div>

        <div class="telDiv">
          <span>性别：</span>
          <select v-model="gender">
            <option selected  value="1">男</option>
            <option  value="2">女</option>
          </select>
        </div>

        <div class="telDiv">
          <span>身份证号：</span>
          <input type="text" placeholder="请输入身份证号" v-model="userIdCard">
        </div>

        <div class="telDiv">
          <span>年龄：</span>
         <input type="number" placeholder="请输入年龄" v-model="age">
        </div>
      </div>
      <div class="loginBtn" @click="infoSubmit">保存信息</div>
    </div>
      
</template>

<script>
 import * as api from '@/api'
 import { mapMutations } from 'vuex';
 import JmmToast from '@/components/JmmToast'
 let phoneRegular = /^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(16[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$/
 let ageRegular = /^[0-9]*$/
 let nicknameRegular = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
  export default {
    name: 'login',
    data () {
      return {
        id:'',
        userId:'',
        token:'',
        sign:'',
        nickName:'',
        mobile:'',
        gender:'',
        userIdCard:'',
        age:'',
      }
    },
    components: {
      JmmToast,
    },
    created() {
      this.merchantId = this.$route.query.merchantId;
      if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
        localStorage.setItem('cityMerchantId', this.merchantId);
      }
      this.token = this.$route.query.token;
      this.sign=localStorage.getItem("reSIGN");
    },
    computed: {
   
    },
    mounted: function () {
      // this.workexp();
           if(localStorage.getItem("reSIGN")==null){
        //跳转首页登录
        window.location.href="weblogin.html#/?timeer=66666";
        
      };
      this.info();
    },
    methods: {
        async info(){
          let _this = this;
          try{
            let testToken = 'fjenpjlnjinhejcmcnkhcefeehlcaidf';
           
            localStorage.setItem('reToken', _this.token==undefined?testToken: _this.token);
            
            let info = {
              sign:this.sign==undefined?"":_this.sign,
            }
            const {code,data,message} = await api.user.userInfo(info);
            console.log(data);
            if (code == "000000") {
              this.id = data.id
              this.userId = data.userId
              this.nickName = data.nickname
              this.mobile = data.mobile
              this.gender = data.gender
              this.userIdCard = data.userIdCard
              this.age = data.age
            } else {
              if(code=="0"){
              //跳转首页登录
              localStorage.clear();
              window.location.reload();
              }
              else{
              JmmToast(code+" "+message)
              }
             
              // HyrToast(submsg || msg)
            }
          } catch (err) {
            console.log(err);
          }
        },
        async infoSubmit(){
          let _this = this;
          if(_this.nickName==''){
            JmmToast("用户昵称不能为空")
          }
          if(_this.mobile==''){
            JmmToast("手机号不能为空")
          }
          //if(_this.userIdCard==''){
           // JmmToast("身份证号不能为空")
          //}
          //if(_this.age==''){
          //  JmmToast("年龄不能为空")
          //}
          if (!nicknameRegular.test(_this.nickName)) {
            JmmToast('用户昵称只能包含汉字和字母')
            return
          }
          if (!phoneRegular.test(_this.mobile)) {
            JmmToast('请输入正确的手机号码')
            return
          }
          //验证身份证
          if(_this.userIdCard!=''){
            let userIdCard = _this.userIdCard;
            if(this.validid.cnid(userIdCard)!=true){
              JmmToast('身份证输入错误')
              return
            }
          }
          if(_this.age!=''){
            if (!ageRegular.test(_this.age)) {
              JmmToast('年龄请输入数字')
              return
            }
          }
          try{
            let testToken = 'fjenpjlnjinhejcmcnkhcefeehlcaidf';
          
            localStorage.setItem('reToken', _this.token==undefined?testToken: _this.token);
            // const {code,data,message} = await api.user.userInfo(mySign);
            // localStorage.setItem("reToken", this.token);
            let info = {
              id:_this.id,
              sign:_this.sign==undefined?"":_this.sign,
              userId:_this.userId,
              nickname:_this.nickName,
              mobile:_this.mobile,
              gender:_this.gender==undefined?1:_this.gender,
              userIdCard:_this.userIdCard==undefined?"":_this.userIdCard,
              age:_this.age==undefined?0:_this.age,
            };
            const {code,data,message} = await api.user.webuserUpdate(info);
            console.log(data);
            if (code == "000000") {
              JmmToast("修改成功");
              this.$router.go(0)
            } else {
              if(code=="0"){
              //跳转首页登录
              localStorage.clear();
              window.location.reload();
              }
              else{
                 JmmToast(code+" "+message);
                 console.log(code+" "+message);
              }
             
            }
          } catch (err) {
            console.log(err);
          }
        },


  
  
    },
   
  }
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'

.webwrap{
   width :100%;
   max-width :800px;
   height :100%;
   overflow :hidden;
   background :#ffffff;
   margin-left :auto;
   margin-right :auto;
}

.webwrap .inputForm_info{
   background:#fff;
}

.webwrap .inputForm_info .telDiv{
  width:calc(100% - 150px);
  margin-left:auto;
  margin-right :auto;
  height:110px;
  border-bottom:1px solid #ddd;
  display:flex;
}

 .webwrap .loginBtn{
   width:calc(100% - 150px);
   max-width :400px;
   height:90px;
   line-height:90px;
   background:$background;
   border-radius:0px;
   font-size:34px;
   text-align:center;
   color:$color;
   cursor:pointer;
   left:0;
   right:0;
   bottom:40px;
   margin:auto;
   position: absolute;
}

.webwrap .inputForm_info .telDiv input{
    width:calc(100% - 60px);
    text-align:right;
    height: 80px;
    font-size: 30px;
    margin-top 15px;
   
}

.webwrap .inputForm_info .telDiv input::-webkit-input-placeholder{ /*WebKit browsers*/

font-size :26px;
line-height :36px;

}

.webwrap .inputForm_info .telDiv input::-moz-input-placeholder{ /*Mozilla Firefox*/

font-size :26px;
line-height :36px;

}

.webwrap .inputForm_info .telDiv input::-ms-input-placeholder{ /*Internet Explorer*/ 

font-size :26px;
line-height :36px;

}


.webwrap .inputForm_info .telDiv span{
     display:inline-block;
     float:left;
     align-self:center;
     width:200px; 
     font-size: 30px;
     
}

.webwrap .inputForm_info .telDiv select{
    margin-left:calc(100% - 240px);
    width:110px;
    height:80px;
    text-align:right;
    font-size: 30px;
    margin-top 15px;

}

.webwrap .clearBoth{
 clear:both;  
}
  
.webwrap .leftRouter{
 float:$floLeft
}
 
.webwrap .rightRouter{
 float:$florRight
}
 
 
       
</style>



// WEBPACK FOOTER //
// src/view/webinfo/index.vue